import React, { FC } from 'react';
import { Checkbox } from 'components/EnumInput';

import styles from './BlueCheckbox.module.scss';
import clsx from 'clsx';

type BlueCheckboxProps = React.ComponentProps<typeof Checkbox>;

export const BlueCheckbox: FC<BlueCheckboxProps> = ({
  className,
  labelClassName,
  ...props
}) => {
  return (
    <Checkbox
      className={clsx(styles.blueCheckbox, className)}
      labelClassName={clsx(styles.label, labelClassName)}
      {...props}
    />
  );
};
